// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__zamS2","spin":"PrintLink_spin__e0NMq"};